import BubbleAlert from '@go-client/components/BubbleUI/BubbleAlert';
import { useBubbleDrawerTools } from '@go-client/components/BubbleUI/BubbleDrawer';
import {
  BubbleFormActions,
  BubbleFormFooter,
  BubbleFormHeader,
  FormPageComponentHelpfulProps,
} from '@go-client/components/BubbleUI/BubbleForm';
import { FormGenericContainer } from '@go-client/components/FormGenericContainer';
import {
  EventTemplateFormikForm,
  EventTemplateFormikPackagesSubTab,
} from '@go-client/components/Formik/EventTemplateFormik';
import { FormikProps } from 'formik';
import React from 'react';
import { RESERVABLE_SCHEDULE_BREADCRUMBS } from '../ReservableSchedulePath';

interface EnterPackagesPagePropsBase {
  isBusy: boolean;
  setIsBusy: (isBusy: boolean) => void;
  libraryLocked: boolean;
  eventFormik: FormikProps<EventTemplateFormikForm>;
}

type EnterPackagesPageProps = EnterPackagesPagePropsBase &
  FormPageComponentHelpfulProps<RESERVABLE_SCHEDULE_BREADCRUMBS>;

export default function EnterPackagesPage(props: EnterPackagesPageProps) {
  const forwardDisabled = (props.eventFormik.errors.reservablePackages ?? []).length > 0;

  const { scrollToBottom } = useBubbleDrawerTools();

  return (
    <div className="eaf-1">
      <FormGenericContainer
        className="h-screen flex flex-col"
        bodyClassName="flex-grow flex flex-col"
        footer={() => (
          <>
            <BubbleFormFooter
              className="text-slate-dark mr-auto"
              items={[{ label: 'Experience Selected', value: props.eventFormik.values.title }]}
            />
            <BubbleFormActions
              isBusy={props.isBusy}
              forwardTitle={props.forwardTitle || 'Next: Addons'}
              backTitle={props.backTitle}
              onGoForward={props.onGoForward}
              onGoBack={props.onGoBack}
              forwardDisabled={forwardDisabled}
            />
          </>
        )}
      >
        <BubbleFormHeader<RESERVABLE_SCHEDULE_BREADCRUMBS>
          title={props.title || 'Create Experience'}
          subtitle={props.subtitle || 'Add Packages'}
          pageIndex={props.pageIndex ?? 1}
          onClose={props.onClose}
          activeBreadcrumb="packages"
          breadcrumbs={props.breadcrumbs}
          onBreadcrumbClick={props.onBreadcrumbClick}
        />
        {props.libraryLocked && (
          <BubbleAlert className="mb-3" variant="ocean">
            <span className="font-semibold">This template cannot be modified.</span> It may be a
            brand level event or you lack library permissions.
          </BubbleAlert>
        )}
        <EventTemplateFormikPackagesSubTab
          formik={props.eventFormik}
          type="create"
          readOnly={props.libraryLocked}
          onAddNewPackages={scrollToBottom}
          onSkip={props.onGoForward}
        />
      </FormGenericContainer>
    </div>
  );
}
